var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarOffers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_2574)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    d: "M16.9767 4.54511L6.67167 8.66678H3.875C2.84167 8.66678 2 9.50844 2 10.5418V12.8334C2 13.8151 2.77083 14.5001 3.875 14.5001H4.58333L5.34 19.7968C5.38417 20.1051 5.6475 20.3334 5.95833 20.3334H8.45833C8.63667 20.3334 8.80583 20.2576 8.925 20.1251C9.04333 19.9926 9.1 19.8159 9.08 19.6384L8.58833 15.2668L16.9758 18.6218C17.0517 18.6518 17.13 18.6668 17.2083 18.6668C17.3308 18.6668 17.4542 18.6301 17.5592 18.5593C17.7308 18.4426 17.8333 18.2493 17.8333 18.0418V5.12511C17.8333 4.91761 17.7308 4.72428 17.5592 4.60761C17.3867 4.49094 17.1683 4.46761 16.9767 4.54511Z",
    fill: "#808191"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    d: "M19.6822 9.78009L21.7655 8.11343C22.0347 7.89759 22.0788 7.50426 21.863 7.23426C21.6463 6.96593 21.2538 6.92259 20.9838 7.13676L18.9005 8.80343C18.6313 9.01926 18.5872 9.41259 18.803 9.68259C18.9263 9.83593 19.108 9.91676 19.2913 9.91676C19.4288 9.91676 19.5663 9.87176 19.6822 9.78009Z",
    fill: "#808191"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    d: "M19.6822 14.22C19.4138 14.0058 19.0205 14.0492 18.803 14.3175C18.5872 14.5867 18.6313 14.9808 18.9005 15.1967L20.9838 16.8633C21.0997 16.955 21.2372 17 21.3747 17C21.558 17 21.7397 16.9192 21.863 16.7658C22.0788 16.4967 22.0347 16.1025 21.7655 15.8867L19.6822 14.22Z",
    fill: "#808191"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    d: "M21.3753 11.375H19.292C18.947 11.375 18.667 11.655 18.667 12C18.667 12.345 18.947 12.625 19.292 12.625H21.3753C21.7203 12.625 22.0003 12.345 22.0003 12C22.0003 11.655 21.7203 11.375 21.3753 11.375Z",
    fill: "#808191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_2574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarOffers);
export default __webpack_public_path__ + "static/media/sidebar_offers.6676506a61d67d38807b240bcea3acff.svg";
export { ForwardRef as ReactComponent };